export const WYt = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_849_5429)">
        <path
          d="M19.5829 5.42142C19.4696 5.01745 19.249 4.65171 18.9445 4.36309C18.6314 4.06559 18.2477 3.85279 17.8295 3.74476C16.2645 3.33226 9.99454 3.33226 9.99454 3.33226C7.38065 3.30252 4.7674 3.43332 2.16954 3.72392C1.75136 3.83993 1.36834 4.0575 1.05454 4.35726C0.746204 4.65392 0.522871 5.01976 0.406204 5.42059C0.125949 6.93038 -0.0102189 8.46338 -0.000462243 9.99892C-0.0104622 11.5331 0.125371 13.0656 0.406204 14.5773C0.520371 14.9764 0.742871 15.3406 1.05204 15.6348C1.3612 15.9289 1.7462 16.1414 2.16954 16.2539C3.75537 16.6656 9.99454 16.6656 9.99454 16.6656C12.6118 16.6954 15.2283 16.5646 17.8295 16.2739C18.2477 16.1659 18.6314 15.9531 18.9445 15.6556C19.2489 15.367 19.4693 15.0012 19.582 14.5973C19.8696 13.0881 20.0094 11.5544 19.9995 10.0181C20.0212 8.47526 19.8815 6.93439 19.5829 5.42059V5.42142ZM8.0012 12.8523V7.14642L13.2179 9.99976L8.0012 12.8523Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_849_5429">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default WYt;
